import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import {BaseDatepickerComponent} from './base-datepicker.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { YEAR_FORMAT } from '../../utils/date-formats';

@Component({
  selector: 'app-year-datepicker',
  standalone: true,
  imports: [BaseDatepickerComponent, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatIconModule, MatButtonModule, DatePipe],
  providers: [
    provideNativeDateAdapter(),
    {provide: MAT_DATE_FORMATS, useValue: YEAR_FORMAT},
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    DatePipe
  ],
  template: `
    <div class="datepicker-container">
      <button mat-icon-button (click)="decrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <app-base-datepicker [date]="date" (dateChange)="onDateChange($event)">
        <div class="datepicker-container">
          <span class="datepicker-label">{{ date | date : 'yyyy' : 'de-DE' }}</span>
          <mat-form-field appearance="fill" class="datepicker-field">
            <input matInput [matDatepicker]="picker" [value]="date" (dateChange)="onDateChange($event.value)" class="hidden-input" />
            <mat-datepicker-toggle matIconSuffix [for]="picker" class="datepicker-arrow-button"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="multi-year" (yearSelected)="onYearSelected($event, picker)" panelClass="year-only-datepicker"></mat-datepicker>
          </mat-form-field>
        </div>
      </app-base-datepicker>
      <button mat-icon-button (click)="incrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./datepicker.component.css']
})
export class YearDatepickerComponent {
  private datePipe = inject(DatePipe);

  @Input() date: Date = new Date();
  @Output() dateChange = new EventEmitter<Date>();

  onDateChange(newDate: Date) {
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  onYearSelected(year: Date, datepicker: any) {
    this.date = new Date(year.getFullYear(), 0); // Set to Jan of selected year
    this.dateChange.emit(this.date);
    datepicker.close();
  }

  incrementDate() {
    const newDate = new Date(this.date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  decrementDate() {
    const newDate = new Date(this.date);
    newDate.setFullYear(newDate.getFullYear() - 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }
}
